import { useEffect } from "react";

// Agrega la clase "is-visible" a los elementos [data-reveal] cuando entran en pantalla.
// También vigila los que se agregan después (cambio de idioma, de app o contenido nuevo)
export const useReveal = () => {
  useEffect(() => {
    const observer =
      "IntersectionObserver" in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.classList.add("is-visible");
                  observer.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
          )
        : null;

    const watch = () => {
      document.querySelectorAll("[data-reveal]:not(.is-visible)").forEach((el) => {
        if (observer) observer.observe(el);
        else el.classList.add("is-visible");
      });
    };

    watch();
    const mutations = new MutationObserver(watch);
    mutations.observe(document.body, { childList: true, subtree: true });

    return () => {
      mutations.disconnect();
      observer?.disconnect();
    };
  }, []);
};
